export const TIMESHEET_CONSTANTS = {
  IMAGES: {
    NO_DATA_FOUND: 'assets/img/no-data-found.png',
  },
  MODAL_CLASSES: {
    DIM_BACKGROUND: 'dim-background',
  },
  CSS_CLASSES: {
    RED_TEXT: 'red-text',
    BLACK_TEXT: 'black-text',
    GREEN_TEXT: 'green-text',
  },
  LABELS: {
    TIMESHEET_TITLE: 'Timesheet',
    MONTH: 'Month',
    UPLOAD_TIMESHEET: 'Upload Timesheet',
    SEARCH: 'Search',
    SUBMIT: 'Submit',
    SELECT_ITEM: 'Select Item',
    GET_CALENDAR: 'Get Calendar',
    HOURS_SUFFIX: ' Hrs',
    OK: 'OK',
  },
  IDS: {
    MONTH_SELECT: 'month_select',
  },
  ICONS: {
    SEARCH: 'search',
    CLOSE: 'close',
    DATE_RANGE: 'date_range',
    FLAG: 'flag',
  },
  TEMPLATE: {
    HOURS_SUFFIX: ' Hrs',
    HOURS_SHORT: 'Hrs'
  },
  MESSAGES: {
    NO_SELECTION_ERROR: 'Please select at least one timesheet to submit',
    NO_SELECTION_TITLE: 'No Selection',
    SELECT_EMPLOYEE: 'Please select at least one employee to submit',
    SUBMISSION_FAILED: 'Failed to submit timesheet',
    SUBMISSION_ERROR: 'Submission Error',
    APPROVED_CANNOT_SUBMIT: 'Approved and Pending Approval timesheets cannot be submitted. Please uncheck them to proceed.',
    FAILED_LOAD_COMMENTS: 'Failed to load leave comments',
    FAILED_SAVE_COMMENT: 'Failed to save comment',
    COMMENT_SAVED_SUCCESS: 'Comment saved successfully',
    FAILED_LOAD_TIMESHEET: 'Failed to load timesheet details',
    FAILED_UPDATE_TIMESHEET_STATUS: 'Failed to update timesheet status',
    NO_PENDING_SUBMISSIONS: 'No pending submissions at this time.',
    NO_PENDING_APPROVALS: 'No pending approvals at this time.',
    SUBMIT_ONLY_ON_LAST_DAY: 'Timesheet for the current month can only be approved or rejected on the last day of the month.',
  },
  TITLES: {
    SUCCESS: 'Success',
    ERROR: 'Error',
    LOAD_ERROR: 'Load Error',
    SAVE_ERROR: 'Save Error',
    SUBMISSION_ERROR: 'Submission Error',
  },
  API_ENDPOINTS: {
    HIRING_LEAVE_COMMENTS: '/hiring/leave-comments',
    HIRING_LEAVE_COMMENT: '/hiring/leave-comment',
  },
  POSITION_STYLES: {
    INITIAL_TOP: '0px',
    INITIAL_LEFT: '0px',
  },
  STATUS: {
    PENDING_SUBMISSION: 'Pending Submission',
    PENDING_APPROVAL: 'Pending Approval',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
  },
  HOURS_SUFFIX: ' Hrs',
  
  CONFIRMATION_DIALOG: {
    TITLE: 'Submit Timesheet',
    SUBMIT_LABEL: 'Submit',
    CANCEL_LABEL: 'Cancel',
    MESSAGE: 'Do you want to submit the timesheet?',
    getMessage: (count: number) =>
      `You have ${count} profile(s) with billable hours. Do you want to submit the timesheet?`,
  },
  APPROVE_CONFIRMATION_DIALOG: {
    TITLE: 'Approve Timesheet',
    SUBMIT_LABEL: 'Approve',
    CANCEL_LABEL: 'Cancel',
    getMessage: (count: number) =>
      `You have selected ${count} profile(s). Do you want to approve the timesheets?`,
  },
  REJECT_CONFIRMATION_DIALOG: {
    TITLE: 'Reject Timesheet',
    SUBMIT_LABEL: 'Reject',
    CANCEL_LABEL: 'Cancel',
    getMessage: (count: number) =>
      `You have selected ${count} profile(s). Do you want to reject the timesheets?`,
  },
  CANCEL_CONFIRMATION_DIALOG: {
    TITLE: 'Not Applicable Timesheet',
    SUBMIT_LABEL: 'Not Applicable',
    CANCEL_LABEL: 'Cancel',
    getMessage: (count: number) =>
      `You have selected ${count} profile(s). Do you want to mark the timesheets as Not Applicable?`,
  },
  EXCLUDE_CONFIRMATION_DIALOG: {
    TITLE: 'Exclude from Timesheets',
    SUBMIT_LABEL: 'Confirm',
    CANCEL_LABEL: 'Cancel',
    MESSAGE: 'This employee will not be included in future timesheets. Do you want to proceed?',
  },
} as const;
